<template>
  <div class="home-box" @click="close" :style="{ 'min-height': isDetail ? '25vh' : '100vh', }">
    <m-header v-if="!isDetail"></m-header>
    <m-tools></m-tools>
    <div class="_s_c" :style="{
      'min-height': isDetail ? '25vh' : '100vh',
    }">
      <div class="title" v-if="categoryName && !isDetail">
        {{ categoryName }}
      </div>
      <div class="filter __s" @click.stop="() => { }" v-if="!isDetail">
        <div class="item" @click="handleClick('type')" :style="{ background: visibleObj.typeVisible ? '#fcfcfc' : '' }">
          类别
          <i class="el-icon-caret-bottom"></i>
          <div class="type-drop" v-show="visibleObj.typeVisible">
            <div class="tab-list">
              <div class="tab" :class="{ active: typeCurrentIndex === index }"
                v-for="(node, index) in nodeList[1].children" :key="index"
                @mouseenter="changeTypeTab(node.children, index)" @click="typeChange(node)">
                <p class="title">
                  {{ node.label }}
                </p>
                <p class="txt">
                  <span v-for="(nodeChild, index) in node.children" :key="index" v-show="index < 2">{{ nodeChild.label
                  }}</span>
                </p>
              </div>
            </div>
            <div class="right-content">
              <div class="content-list" v-for="(node, index) in typeObjList" :key="index">
                <p class="title" @click="typeChange(node)">
                  {{ node.label }}
                </p>
                <p class="txt" v-show="node.children">
                  <span v-for="(nodeChild, index) in node.children" :key="index" @click="typeChange(nodeChild)">{{
                    nodeChild.label
                  }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="item" @click="handleClick('price')" :style="{ background: visibleObj.priceVisible ? '#fcfcfc' : '' }">
          价格
          <i class="el-icon-caret-bottom"></i>
          <div class="drop" v-show="visibleObj.priceVisible" @click="handleClickS">
            <div class="text">自定义价格范围</div>
            <div :style="{ textAlign: 'center' }">
              <el-input @click.stop="() => { }" :style="{ width: '60px' }" size="mini"
                v-model="query.priceMin"></el-input>
              --
              <el-input :style="{ width: '60px' }" size="mini" v-model="query.priceMax"></el-input>
            </div>
            <div :style="{ textAlign: 'center' }">
              <div class="button" @click="applyPrice">应用</div>
              <div class="button" @click="emptyPrice">清空</div>
            </div>
          </div>
        </div>

        <div class="item" @click="handleClick('software')"
          :style="{ background: visibleObj.softwareVisible ? '#fcfcfc' : '' }">
          格式
          <i class="el-icon-caret-bottom"></i>
          <div class="drop" v-show="visibleObj.softwareVisible" @click="handleClickS">
            <div :style="{ textAlign: 'center' }">
            </div>
            <el-checkbox-group v-model="checkedSoftWare" @change="handleSoftChange">
              <div class="option" v-for="(item, index) in softwareList" :key="index">
                <el-checkbox :value="item.id" :label="item.id">{{
                  item.name
                }}</el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>

        <div class="item" @click="handleClick('render')"
          :style="{ background: visibleObj.renderVisible ? '#fcfcfc' : '' }">
          渲染器
          <i class="el-icon-caret-bottom"></i>
          <div class="drop" v-show="visibleObj.renderVisible" @click="handleClickS">
            <div :style="{ textAlign: 'center' }">

            </div>
            <el-checkbox-group v-model="checkedRender" @change="handleRenderChange">
              <div class="option" v-for="(item, index) in renderList" :key="index">
                <el-checkbox :value="item.id" :label="item.id">{{
                  item.name
                }}</el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>

        <div class="item" @click="handleClick('poly')" :style="{ background: visibleObj.polyVisible ? '#fcfcfc' : '' }">
          面数
          <i class="el-icon-caret-bottom"></i>
          <div class="drop" v-show="visibleObj.polyVisible" @click="handleClickS">
            <div :style="{ textAlign: 'center' }">
              <el-input @click.stop="() => { }" v-model="query.surfaceNum" :style="{ width: '120px' }" size="mini"
                placeholder="最大值Poly计数"></el-input>
            </div>
            <div :style="{ textAlign: 'center' }">
              <div class="button" @click="handleSurfaceNum">应用</div>
            </div>
          </div>
        </div>

        <div class="item">
          <el-checkbox v-model="query.isAuth" label="畅快用认证" @change="handleAuthChange"></el-checkbox>
        </div>

        <div class="item" @click="handleClick('rights')"
          :style="{ background: visibleObj.rightsVisible ? '#fcfcfc' : '' }">
          版权
          <i class="el-icon-caret-bottom"></i>
          <div class="drop" v-show="visibleObj.rightsVisible" @click="handleClickS">
            <div :style="{ textAlign: 'center' }">
            </div>
            <el-checkbox-group v-model="checkedRights" @change="handleRightChange">
              <div class="option" v-for="(item, index) in rigthsList" :key="index">
                <el-checkbox :value="item.id" :label="item.id">{{
                  item.name
                }}</el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>

        <div class="item">
          <el-checkbox label="动画" v-model="query.animationChecked" @change="checkedChange"></el-checkbox>
        </div>
        <div class="item">
          <el-checkbox label="绑定" v-model="query.bindChecked" @change="checkedChange"></el-checkbox>
        </div>

        <div class="item">
          <el-checkbox label="扫描" v-model="query.scanning" @change="checkedChange"></el-checkbox>
        </div>

        <div class="item">
          <el-checkbox label="USD" v-model="query.omniverse" @change="checkedChange"></el-checkbox>
        </div>
        <div class="item">
          <el-checkbox label="免费" v-model="query.isFree" @change="isFreeChange"></el-checkbox>
        </div>
        <div class="item">
          <el-checkbox label="搜币" v-model="query.isCharge" @change="isChargeChange"></el-checkbox>
        </div>
        <div class="item">
          <el-checkbox label="积分" v-model="query.isScore" @change="isScoreChange"></el-checkbox>
        </div>
        <div class="item memberitem">
          <img class="viplogo" src="../assets/member/C_VIP_Logo.png" alt="">
          <el-checkbox label="会员专享" v-model="query.mxTypeFlag" @change="isMemberChange"></el-checkbox>
        </div>
        <div class="item" @click="handleClick('sort')" :style="{
          float: 'right',
          marginRight: '20px',
          background: visibleObj.sortVisible ? '#fcfcfc' : '',
        }">
          <i class="el-icon-caret-bottom">{{ sortName }}</i>
          <div class="drop" v-show="visibleObj.sortVisible" @click="handleClickS">
            <div class="option" @click="setSort(1)">价格降序</div>
            <div class="option" @click="setSort(2)">价格升序</div>
            <div class="option" @click="setSort(3)">最新发布</div>
            <div class="option" @click="setSort(4)">最多购买</div>
            <div class="option" @click="setSort(5)">综合排序</div>
          </div>
        </div>
      </div>

      <!-- 资产 -->
      <div :style="{ minHeight: '0vh' }" ref="resourcePage">
        <div class="_assets_c">
          <div class="noData"></div>
          <div class="__a_noresult" v-if="!list.length">
            {{ emptyTxt }}
          </div>
          <div v-for="(item, index) in list" class="_a_i" :style="{
            lineHeight: isDetail ? '250px' : '315px',
            width: isDetail ? '250px' : '315px',
            height: isDetail ? '250px' : '315px',
          }" :key="index" @click="goDetail(item.assetsId)">
            <div class="commercial_use_mark" v-if="copyrightIcon(item.copyright)">
              <img src="../assets/commercial_use_mark.png" />
            </div>
            <img :src="linkAllImgUrl(item.imageUrl)" />
            <div class="absolute_top none" :style="{ width: isDetail ? '250px' : '315px' }">
              <div :style="{
                textAlign: 'left',
                paddingLeft: '10px',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                lineHeight: '40px',
              }">
                {{ item.title }}
              </div>
              <div :style="{
                textAlign: 'left',
                paddingLeft: '10px',
                fontSize: '12px',
                color: '#fff',
                lineHeight: '20px',
                marginTop: '-6px',
              }">
                <span v-if="item.priceType == 0 && item.price == 0">
                  免费
                </span>
                <span v-else-if="item.priceType == 3">
                  免费
                </span>

                <span v-else-if="item.priceType == 0 && item.price !== 0">积分: {{ item.price }}
                </span>
                <span v-else-if="item.priceType == 2">积分: {{
                  item.price
                }}</span>

                <span v-else-if="item.priceType == 1 && item.price !== 0">搜币: {{
                  item.price
                }}</span>

              </div>
              <img v-if="item.mxType === 1" class="cviplogo" src="../assets/member/C_VIP_Logo.png" alt="">
            </div>
            <div :style="{ width: isDetail ? '250px' : '315px' }" :class="[
              'absolute_bottom none',
              modelFlag && index == oldIndex ? 'item-show' : '',
            ]" @click.stop="handleModel(index, item.assetsId)">
              <template v-if="modelFlag && index == oldIndex">
                {{ modelFlag ? "关闭" : "详情" }}
              </template>
              <template v-else> 详情 </template>
              <i class="el-icon-arrow-down"></i>
              <i v-if="userInfo.aId != item.creatorId" class="el-icon-shopping-cart-2 cart"
                @click.stop="addCart(item.assetsId)">
              </i>
            </div>
          </div>
          <div ref="detailModel" class="item-detail-model" v-show="modelFlag">
            <div class="banner" v-if="imgList">
              <el-carousel :autoplay="false" arrow="always" height="550px" indicator-position="none">
                <el-carousel-item v-for="(item, index) in imgList" :key="index">
                  <div :style="{ textAlign: 'center' }">
                    <el-image style="height: 550px" :src="linkAllImgUrl(item.url)" fit="scale-down">
                    </el-image>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="_content">
              <div :style="{
                color: '#fff',
                fontSize: '22px',
                lineHeight: '40px',
                position: 'relative',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                cursor: 'pointer',
              }" @click="goDetail(addCartId)">
                {{ title }}
              </div>

              <div :style="{
                color: '#fff',
                fontSize: '14px',
                height: '30px',
                lineHeight: '10px',
              }">
                <span v-if="priceType == 0 && price == 0">免费</span>
                <span v-else-if="priceType == 3">免费</span>

                <span v-else-if="priceType == 0 && price !== 0">积分: {{
                  price
                }}</span>

                <span v-else-if="priceType == 2">积分: {{
                  price
                }}</span>

                <span v-else-if="priceType == 1 && price !== 0">搜币: {{
                  price
                }}</span>
              </div>
              <div :style="{ position: 'relative', marginBottom: '10px' }">
                <div v-if="userInfo.aId != assetCreatorId" @click.stop="addCart(addCartId)" :style="{
                  backgroundColor: '#ff8135',
                  width: '90px',
                  height: '30px',
                  lineHeight: '30px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  textAlign: 'center',
                  cursor: 'pointer',
                  color: '#fff',
                }">
                  加入购物车
                </div>

                <div @click="goDetail(addCartId)" :style="{
                  color: '#6ec6ec',
                  fontSize: '12px',
                  position: 'absolute',
                  top: '5px',
                  right: '10px',
                  cursor: 'pointer',
                }">
                  查看详情 <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div>
                <div :style="{ padding: '10px 10px 10px 0px' }" v-if="copyrightText.length">
                  <span :style="{
                    color: '#fff',
                    fontSize: '12px',
                    marginRight: '10px',
                  }">
                    版权:
                  </span>

                  <el-tag :style="{ marginRight: '10px', marginBottom: '5px' }" size="medium"
                    v-for="(item, index) in copyrightText" :key="index">{{ item }}</el-tag>
                </div>
                <div :style="{ padding: '10px 10px 10px 0px' }" v-if="classifyList.length">
                  <span :style="{
                    color: '#fff',
                    fontSize: '12px',
                    marginRight: '10px',
                  }">
                    分类:
                  </span>

                  <el-tag :style="{ marginRight: '10px', marginBottom: '5px' }" v-for="(item, index) in classifyList"
                    :key="index">{{ item }}</el-tag>
                </div>
                <div :style="{ padding: '10px 10px 10px 0px' }" v-if="renderList.length">
                  <span :style="{
                    color: '#fff',
                    fontSize: '12px',
                    marginRight: '10px',
                  }">
                    渲染器:
                  </span>
                  <el-tag :style="{ marginRight: '10px', marginBottom: '5px' }" v-for="(item, index) in renderText"
                    :key="index">{{ item }}</el-tag>
                </div>
                <div :style="{ padding: '10px 10px 10px 0px' }" v-if="labelList.length">
                  <span :style="{
                    color: '#fff',
                    fontSize: '12px',
                    marginRight: '10px',
                  }">
                    活动:
                  </span>
                  <el-tag :style="{ marginRight: '10px', marginBottom: '5px' }" size="medium"
                    v-for="(item, index) in labelList" :key="index">{{ item }}</el-tag>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="__s" :style="{ textAlign: 'center', margin: '20px 0' }" v-if="!isDetail && list.length">
        <el-pagination background layout="prev, pager, next" :current-page="pageObj.pageNum" :total="total"
          :page-size="pageObj.pageSize" @current-change="pageChange" :hide-on-single-page="true">
        </el-pagination>
      </div>
    </div>
    <m-footer v-if="!isDetail"></m-footer>

    <div v-if="isNoCart" class="dialogFox">此模型为会员专享，<span
        style="color: #FF9900; font-size: 18px;font-weight: bold; cursor: pointer;" @click="openMemberClick">立即开通</span>会员
      <div class="cancelX" @click="cancelClick">X</div>
    </div>
    <!-- 会员充值弹窗 -->
    <openMembership @memberHidden="memberHidden" v-if="isVisible" @isBuySuccess="isBuySuccess"
      @changeMemType="changeMemType" :memberType="memberType">
    </openMembership>
    <!-- 充值成功弹窗 -->
    <successRechart :onceNum="onceNum" :isvisib="isvisib" @isBuySuccess="isBuySuccess"></successRechart>
  </div>
</template>

<script>
import openMembership from '@/components/openMembership/index.vue'
import successRechart from '@/components/successRechart/index.vue'
import { mapListApi, classListApi } from "@/api/resource";
import {
  queryAssetsByCondition,
  addCart,
  getCart,
  classIdApi,
  getDetail,
  getLabelById,
  industryIdApi,
} from "@/api/extra";
import { mapGetters, mapMutations } from "vuex";
import { decode } from "js-base64";
import commonMixin from "@/mixins/commonMixin";
export default {
  mixins: [commonMixin],
  props: {
    isDetail: {
      type: Boolean,
      default: false,
    },
    detailCategory: {
      type: Array,
      default: () => {
        return [];
      },
    },
    detailAssId: {
      type: Number,
      default: () => {
        return 0;
      },
    },
  },
  components: {
    openMembership,
    successRechart
  },
  data () {
    return {
      // 搜索
      query: {
        copyright: {
          id: null,
          name: "",
        },
        surfaceNum: null,
        isAuth: false,
        sortType: 5,
        animationChecked: false,
        bindChecked: false,
        scanning: false,
        omniverse: false,
        isFree: false,
        isCharge: false,
        isScore: false, //积分
        priceMax: null,
        priceMin: null,
        mxTypeFlag: false
      },
      typeCurrentIndex: 0,
      listAll: 0,
      typeObjList: [],
      softwareList: [],
      checkedRender: [],
      renderList: [],
      rigthsList: [],
      checkedRights: [],
      checkedSoftWare: [],
      labelList: [],
      softList: [],
      title: "",
      priceType: "",
      price: "",
      imgList: [],
      drenderList: [],
      copyrightList: [],
      classifyList: [],
      includeList: [],
      industryList: [],
      softwareIdList: [],
      rendererIdList: [],
      copyright: "",
      isShowPrice: false,
      isShowSoftware: false,
      visibleObj: {
        priceVisible: false,
        softwareVisible: false,
        renderVisible: false,
        polyVisible: false,
        authVisible: false,
        rightsVisible: false,
        sortVisible: false,
        typeVisible: false,
      },
      list: [],
      emptyTxt: "数据加载中", //无内容文字
      pageObj: {
        pageNum: 1,
        pageSize: 96,
      },
      total: 0,
      categoryName: "3D模型",
      modelFlag: false,
      oldIndex: -1,
      userInfo: [],
      /* 类型：0:模型，1:父子模型 */
      nodeList: [
        {
          value: "0_1",
          label: "模型类型",
          leaf: false,
          type: 0,
          children: [],
        },
        {
          value: "1_1",
          label: "模型类别",
          leaf: false,
          type: 1,
          children: [],
        },
      ],
      categoryId: "",
      // 分类级联值
      cascaderCategorys: [],
      // 进入时
      inCategoryName: "3D模型",

      assetCreatorId: "",
      countNumHY: null,
      countNumMF: null,
      isNoCart: false,
      isVisible: false,
      memberType: 2,
      onceNum: null,
      isvisib: false,
      memberModelsList: []
    };
  },
  created () {
    const {
      query: { name },
    } = this.$route;
    if (name) {
      this.categoryName = name;
      this.inCategoryName = JSON.parse(JSON.stringify(name));
      localStorage.setItem("searchText", name);
    } else {
      localStorage.removeItem("searchText");
    }
    let arr = this.GET_USER_INFO.token.split(".");
    if (arr.length < 2) {
      this.userInfo = {
        aId: "-1",
      };
    } else {
      this.userInfo = JSON.parse(decode(arr[1]));
    }
    // 存在返回並為true
    if (
      localStorage.getItem("detailGoBackSearch") &&
      localStorage.getItem("detailGoBackSearch") == "true"
    ) {
      // 歷史記錄
      let storeSearchRecord = JSON.parse(
        localStorage.getItem("storeSearchRecord")
      );
      // 賦值為歷史
      this.query = storeSearchRecord.query;
      this.checkedSoftWare = storeSearchRecord.checkedSoftWare;
      this.checkedRender = storeSearchRecord.checkedRender;
      this.checkedRights = storeSearchRecord.checkedRights;
      // 分类
      this.categoryId = storeSearchRecord.categoryId;
      // 分类级联值
      this.cascaderCategorys = storeSearchRecord.cascaderCategorys;

      this.inCategoryName = storeSearchRecord.inCategoryName;
    }

    this.getSoftware();
    this.getRightsList();
    this.queryAssetsByCondition();
    this.getSRenderList();
    this.classIdApi();
    this.getSoftList();
    this.getRenderList();
    this.getCopyrightList();
    this.nodeList.forEach((node) => {
      let params = {
        type: node.type,
        parentId: node.value.split("_")[1],
      };
      classListApi(params).then(async (res) => {
        if (res.code === 200) {

          let nodeList = [];
          if (node.type == 0) {
            nodeList = res.data.map((item) => {
              return {
                type: 0,
                value: `0_${item.categoryId}`,
                label: item.categoryName,
              };
            });
            node.children = nodeList;
          } else {
            this.recursionQueryTree(node, res.data);
            this.typeObjList = this.nodeList[1].children[0].children;
          }
        }

      });
    });
    window.onresize = () => {
      this.modelFlag = false;
    };
  },

  beforeRouteUpdate (to, from, next) {
    if (to.fullPath == to.path) {
    }
    next();
  },

  destroyed () {
    localStorage.setItem("detailGoBackSearch", false);
  },

  computed: {
    ...mapGetters(["GET_USER_INFO"]),
    sortName () {
      switch (this.query.sortType) {
        case 1:
          return "价格降序";
        case 2:
          return "价格升序";
        case 3:
          return "最新发布";
        case 4:
          return "最多购买";
        case 5:
          return "综合排序";
        default:
          return "综合排序";
      }
    },
    softText () {
      let strArr = [];
      let arr = this.softList.filter((item) =>
        this.softwareIdList.includes(item.id)
      );
      arr.forEach((item) => {
        strArr.push(item.name);
      });
      return strArr;
    },

    renderText () {
      let strArr = [];
      let arr = this.renderList.filter((item) =>
        this.rendererIdList.includes(item.id)
      );

      arr.forEach((item) => {
        strArr.push(item.name);
      });

      return strArr;
    },
    copyrightText () {
      let strArr = [];
      let arr = this.copyrightList.filter((item) => this.copyright == item.id);
      arr.forEach((item) => {
        strArr.push(item.name);
      });
      return strArr;
    },

    // 商用版权
    copyrightIcon () {
      return (val) => {
        if (val == 95 || val == 97) {
          return true;
        } else {
          return false;
        }
      };
    },
  },
  methods: {
    ...mapMutations({
      SET_CART_VISIBLE: "SET_CART_VISIBLE",
      SET_CART_BADGE: "SET_CART_BADGE",
      SET_COUNT_HY: "SET_COUNT_HY",
      SET_COUNT_MF: "SET_COUNT_MF"
    }),
    recursionQueryTree (node, data) {
      let nodeList = data.map((item) => {
        return {
          type: 0,
          value: `0_${item.categoryId}`,
          label: item.categoryName,
          children:
            item.menuCategoryList.length > 0
              ? item.menuCategoryList
              : undefined,
        };
      });
      node.children = nodeList;
      node.children.forEach((item) => {
        if (item.children) {
          this.recursionQueryTree(item, item.children);
        }
      });
    },
    isAuthor () {
      if (!this.GET_USER_INFO.token) {
        return false
      } else {
        let arr = this.GET_USER_INFO.token.split('.')
        let userInfo = JSON.parse(decode(arr[1]))
        return userInfo.aId
      }
    },

    getDetail (id) {
      let params = {
        id: id,
        aId: this.isAuthor()
      }
      getDetail(params).then((res) => {

        if (res && res.code === 200) {

          this.addCartId = id;
          this.imgList = res.data.imageList || [];

          this.title = res.data.title;
          this.priceType = res.data.priceType;
          this.price = res.data.price;
          this.getLabel(res.data.labelIdList || []);
          this.getClass(res.data.classifyIdList || []);
          this.getIndustry(res.data.industryIdList || []);
          this.softwareIdList = res.data.softwareIdList || [];
          this.rendererIdList = res.data.rendererIdList || [];
          this.copyright = res.data.copyright || "";
          this.remark = res.data.remark;
          this.assetCreatorId = res.data.creatorId;
        }
      });
    },

    /* 获取软件列表 */
    getSoftList () {
      mapListApi({
        type: 2,
      }).then((res) => {
        if (res.code === 200) {
          this.softList = res.data;
        }
      });
    },
    /* 获取渲染器列表 */
    getRenderList () {
      mapListApi({
        type: 4,
      }).then((res) => {
        if (res.code === 200) {
          this.drenderList = res.data;
        }
      });
    },
    /* 获取包含 */
    getIncludeList () {
      mapListApi({
        type: 5,
      }).then((res) => {
        if (res.code === 200) {
          this.includeList = res.data;
        }
      });
    },
    /* 获取版权类型列表 */
    getCopyrightList () {
      mapListApi({
        type: 6,
      }).then((res) => {
        if (res.code === 200) {
          this.copyrightList = res.data;
        }
      });
    },
    /* 获取已选行业 */
    getIndustry (industryIdList) {
      const arr = industryIdList.map((item) => industryIdApi(item));
      Promise.all(arr).then((res) => {
        let arr = [];
        res.forEach((item) => {
          if (item.code == 200) {
            arr.push(item.data.name);
          }
        });
        this.industryList = arr;
      });
    },

    /* 获取标签 */
    getLabel (labelIdList) {
      const arr = labelIdList.map((item) => getLabelById(item));
      Promise.all(arr).then((res) => {
        let arr = [];
        res.forEach((item) => {
          if (item.code == 200 && item.data.name) {
            arr.push(item.data.name);
          }
        });
        this.labelList = arr;
      });
    },
    /* 获取分类 */
    getClass (classifyIdList) {
      const arr = classifyIdList.map((item) => classIdApi(item));
      Promise.all(arr).then((res) => {
        let arr = [];

        res.forEach((item) => {
          if (item.code == 200) {
            arr.push(item.data.categoryName);
          }
        });
        this.classifyList = arr;
      });
    },

    // 添加关闭展览的动作
    handleModelClose () {
      if (this.$refs.detailModel.classList.contains("show")) {
        this.oldIndex = -1;
        // setTimeout(() => {
        this.$refs.detailModel.classList.remove("down-animate", "show");
        this.$refs.detailModel.classList.add("up-animate");
        // }, 400)
        this.modelFlag = false;
      }
    },

    handleModel (index, id) {
      let lineItemCount = Math.floor(document.body.clientWidth / 315);
      if (this.isDetail) {
        lineItemCount = Math.floor(1500 / 250);
      }
      let line = Math.ceil((index + 1) / lineItemCount),
        dom =
          document.querySelectorAll("._assets_c ._a_i")[line * lineItemCount];

      if (dom) {
        let domParent = dom.parentNode;
        domParent.insertBefore(this.$refs.detailModel, dom);
      } else {
        document
          .querySelector("._assets_c")
          .appendChild(this.$refs.detailModel);
      }
      this.getDetail(id);
      //若两次点击一致
      if (index == this.oldIndex) {
        //当前处于展开状态，关闭弹窗
        if (this.$refs.detailModel.classList.contains("show")) {
          this.oldIndex = -1;
          // setTimeout(() => {
          this.$refs.detailModel.classList.remove("down-animate", "show");
          this.$refs.detailModel.classList.add("up-animate");
          // }, 400)
          this.modelFlag = false;
        } else {
        }
      } else {
        this.oldIndex = index;
        this.modelFlag = true;
        if (this.$refs.detailModel.classList.contains("show")) {
          this.$refs.detailModel.classList.remove("down-animate");
        } else {
          this.$refs.detailModel.classList.remove("up-animate");
          this.$refs.detailModel.classList.add("show", "down-animate");
        }
      }
    },

    handleAuthChange () {
      this.pageObj.pageNum = 1;
      this.queryAssetsByCondition();
    },
    handleSurfaceNum () {
      this.pageObj.pageNum = 1;
      this.queryAssetsByCondition();
    },
    handleSoftChange (e) {
      this.pageObj.pageNum = 1;
      this.queryAssetsByCondition();
    },
    handleRightChange (e) {
      this.pageObj.pageNum = 1;
      this.queryAssetsByCondition();
    },
    handleRenderChange (e) {
      this.pageObj.pageNum = 1;
      this.queryAssetsByCondition();
    },
    isFreeChange () {
      if (this.query.isFree) {
        this.query.isCharge = false
        this.query.isScore = false
        this.query.mxTypeFlag = false
      }
      this.checkedChange()
    },
    isChargeChange () {
      if (this.query.isCharge) {
        this.query.isFree = false
        this.query.isScore = false
        this.query.mxTypeFlag = false
      }
      this.checkedChange()
    },
    /**
     * @ 勾选积分
     */
    isScoreChange () {
      if (this.query.isScore) { // 如果勾选了积分
        this.query.isCharge = false
        this.query.isFree = false
        this.query.mxTypeFlag = false
      }
      this.checkedChange()
    },
    /**
     * @desc 勾选会员
     */
    isMemberChange () {
      if (this.query.mxTypeFlag) { // 勾选了会员
        this.query.isCharge = false
        this.query.isFree = false
        this.query.isScore = false
      }
      this.checkedChange()
    },
    checkedChange () {
      this.pageObj.pageNum = 1;
      this.queryAssetsByCondition();
    },
    setFree () {
      this.query.isFree = true;
      this.visibleObj.priceVisible = false;
      this.pageObj.pageNum = 1;
      this.queryAssetsByCondition();
    },
    setSort (num) {
      this.query.sortType = num;
      this.pageObj.pageNum = 1;
      this.visibleObj.sortVisible = false;
      this.queryAssetsByCondition();
    },
    queryCopyright (item) {
      this.query.copyright.name = item.name;
      this.query.copyright.id = item.id;
      this.visibleObj.rightsVisible = false;
      this.queryAssetsByCondition();
    },
    goDetail (id) {
      // 檢索記錄保存
      let storeSearchRecord = {
        query: this.query,
        // 格式
        checkedSoftWare: this.checkedSoftWare,
        // 渲染器
        checkedRender: this.checkedRender,
        // 版權
        checkedRights: this.checkedRights,
        // 分类
        categoryId: this.categoryId,
        // 分类级联值
        cascaderCategorys: this.cascaderCategorys,
        categoryName: this.categoryName,
        inCategoryName: this.inCategoryName,
      };

      // 保存至localstore
      localStorage.setItem("detailGoBackSearch", false);
      localStorage.setItem(
        "storeSearchRecord",
        JSON.stringify(storeSearchRecord)
      );
      const routeUrl = this.$router.resolve({
        path: "/detail",
        query: { id: id },
      });

      window.open(routeUrl.href, "_blank");
    },
    applyPrice () {
      this.query.isFree = false;
      this.visibleObj.priceVisible = false;
      this.pageObj.pageNum = 1;
      this.queryAssetsByCondition();
    },
    emptyPrice () {
      this.query.isFree = false;
      this.query.priceMin = "";
      this.query.priceMax = "";
      this.visibleObj.priceVisible = false;
      this.pageObj.pageNum = 1;
      this.queryAssetsByCondition();
    },
    close () {
      for (var key in this.visibleObj) {
        this.visibleObj[key] = false;
      }
    },
    getSoftware () {
      mapListApi({
        type: 2,
      }).then((res) => {
        if (res && res.code === 200) {
          let arr = res.data || [];
          if (arr.length > 15) {
            this.softwareList = arr.splice(0, 15);
          } else {
            this.softwareList = arr;
          }
        }
      });
    },
    getSRenderList () {
      mapListApi({
        type: 4,
      }).then((res) => {
        if (res && res.code === 200) {
          let arr = res.data || [];
          if (arr.length > 14) {
            this.renderList = arr.splice(0, 14);
          } else {
            this.renderList = arr;
          }
        }
      });
    },

    classIdApi () {
      const {
        query: { categoryId },
      } = this.$route;
      if (!categoryId) return;
      classIdApi(categoryId).then((res) => {
        if (res && res.code === 200) {
          this.categoryName = res.data.categoryName;
          this.inCategoryName = JSON.parse(
            JSON.stringify(res.data.categoryName)
          );
        }
      });
    },

    /**
     * @ 查询筛选
     */
    queryAssetsByCondition () {
      this.emptyTxt = "数据加载中...";
      const {
        query: {
          categoryId,
          name,
          hy,
          label,
          creatorId,
          creatorName,
          labelName,
          type,
        },
      } = this.$route;
      const { animationChecked, bindChecked, scanning, omniverse } =
        this.query;
      let params = {
        ...this.pageObj,
        sortType: this.query.sortType,
        surfaceNum: this.query.surfaceNum,
        isAuth: !!this.query.isAuth,
        copyrightlist: this.checkedRights,
        softwareIdList: this.checkedSoftWare,
        rendererIdList: this.checkedRender,
        title: name || "",
        includeIdList: [],
      };

      if (type > (-1)) {
        params.type = type;
      }
      if (hy) {
        params.industryIdList = [+hy];
      }
      if (creatorId) {
        params.creatorId = creatorId;
      }
      if (creatorName) {
        this.categoryName = creatorName + "发布的资产";
      }
      if (label) {
        params.labelIdList = [+label];
        this.categoryName = labelName;
      }
      if (this.query.isFree) { // 免费
        params.priceType = 0;
        params.priceMin = 0;
        params.priceMax = 0;

      } else if (this.query.isCharge) { // 收费
        params.priceType = 1;
        params.priceMin = 1;
        params.priceMax = 99999999;

      } else if (this.query.isScore) { // 积分
        params.priceType = 2
        params.priceMin = 1;
        params.priceMax = 99999999;

      } else if (this.query.mxTypeFlag) { // 会员
        params.mxType = 1
        params.priceMin = 1;
        params.priceMax = 99999999;
      } else {
        params.priceMax = this.query.priceMax;
        params.priceMin = this.query.priceMin;

      }

      if (animationChecked) {
        params.includeIdList.push(100);
      }
      if (bindChecked) {
        params.includeIdList.push(101);
      }
      if (scanning) {
        params.includeIdList.push(102);
      }
      if (omniverse) {
        params.includeIdList.push(103);
      }
      if (categoryId && !name) {
        params.classifyIdList = [categoryId];
      }
      if (this.categoryId && !name) {
        params.classifyIdList = [this.categoryId];
      }
      if (this.isDetail && this.detailCategory) {
        params.classifyIdList = this.detailCategory;
        params.pageSize = 6;
      }
      if (this.isDetail && this.detailAssId) {
        params.assetsId = this.detailAssId;
        params.pageSize = 6;
      }

      queryAssetsByCondition(params).then((res) => {

        if (res && res.code === 200) {

          this.modelFlag = false;
          if (res.data.list.length == 0) {
            this.emptyTxt = "对不起，没有找到您的搜索结果。";
            this.recommended = false;
          }
          this.list = res.data.list;
          this.memberModelsList = this.list.filter(item => item.mxType == 1)


          this.total = res.data.total;
        }
      });

    },
    getRightsList () {
      mapListApi({
        type: 6,
      }).then((res) => {
        if (res && res.code === 200) {
          let arr = res.data || [];
          if (arr.length > 10) {
            this.rigthsList = arr.splice(0, 10);
          } else {
            this.rigthsList = arr;
          }
        }
      });
    },
    handleClick (name) {

      for (var key in this.visibleObj) {
        if (key === name + "Visible") {
          this.visibleObj[name + "Visible"] =
            !this.visibleObj[name + "Visible"];
        } else {
          this.visibleObj[key] = false;
        }
      }
    },
    pageChange (pageIndex) {
      // 隐藏展示的模型
      this.handleModelClose();
      this.pageObj = Object.assign({}, this.pageObj, {
        pageNum: pageIndex,
      });
      this.queryAssetsByCondition();
      // 置顶
      this.$refs["resourcePage"].scrollIntoView();
    },
    handleClickS (e) {
      e.stopPropagation();
    },

    /**
     * @desc 加入购物车
     * @param {*} id 
     */
    addCart (id) {
      let memberState = localStorage.getItem('memberState')

      if (!this.GET_USER_INFO.token) {
        this.$router.push(`/login`);
        return;
      }
      if (memberState == 0) { // 是会员
        getCart().then((res) => {
          if (res && res.code === 200) {
            let list = res.data || [];
            let isHas = false;
            list.forEach((item) => {
              if (item.assetsId === id) {
                isHas = true;
              }
            });
            if (isHas) {
              this.$message.warning("当前商品已经在购物车中");
              this.SET_CART_VISIBLE(false);
            } else {
              addCart({
                assetsId: id,
              }).then((res) => {
                if (res && res.code === 200) {

                  this.countNumHY = res.data.countNumHY
                  this.countNumMF = res.data.countNumMF
                  if (res.data.countNumHY <= -1) {
                    this.$message.warning("今日您的免费下载会员模型次数已用尽，剩余模型下载将收费！");
                  } else if (res.data.countNumMF === -1) {
                    this.$message.warning("今日您的免费下载普通模型次数已用尽");
                  } else {
                    this.$message.success("加入购物车成功");
                  }
                  this.SET_CART_VISIBLE(false);
                  // 当不显示购物车对话框时， 需要手动更新购物车数量
                  getCart().then((res) => {
                    if (res && res.code === 200) {
                      let list = res.data || [];
                      this.SET_CART_BADGE(list.length ? list.length : "");
                    }
                  });
                }
              });
            }
          }
        });
      } else { //null/1 不是会员
        const checkdAssetsIds = this.memberModelsList?.map(i => i.assetsId) || [];
        if (checkdAssetsIds.includes(id)) {
          this.isNoCart = true
        } else {
          getCart().then((res) => {
            if (res && res.code === 200) {
              let list = res.data || [];
              let isHas = false;
              list.forEach((item) => {
                if (item.assetsId === id) {
                  isHas = true;
                }
              });
              if (isHas) {
                this.$message.warning("当前商品已经在购物车中");
                this.SET_CART_VISIBLE(false);
              } else {
                addCart({
                  assetsId: id,
                }).then((res) => {
                  if (res && res.code === 200) {

                    this.countNumHY = res.data.countNumHY
                    this.countNumMF = res.data.countNumMF
                    if (res.data.countNumHY <= -1) {
                      this.$message.warning("今日您的免费下载会员模型次数已用尽，剩余模型下载将收费！");
                    } else if (res.data.countNumMF === -1) {
                      this.$message.warning("今日您的免费下载普通模型次数已用尽");
                    } else {
                      this.$message.success("加入购物车成功");
                    }
                    this.SET_CART_VISIBLE(false);
                    // 当不显示购物车对话框时， 需要手动更新购物车数量
                    getCart().then((res) => {
                      if (res && res.code === 200) {
                        let list = res.data || [];
                        this.SET_CART_BADGE(list.length ? list.length : "");
                      }
                    });
                  }
                });
              }
            }
          });
        }

      }

    },
    classChange (changeValue) {

      if (changeValue.length > 0) {
        this.categoryId = changeValue[changeValue.length - 1].split("_")[1];
        let labels = this.$refs["saveTagInput"].getCheckedNodes()[0].pathLabels;
        this.categoryName = labels[labels.length - 1];

      } else {
        const {
          query: { name },
        } = this.$route;

        this.categoryName = this.inCategoryName;

        this.categoryId = "";
      }
      this.pageObj.pageNum = 1;
      this.queryAssetsByCondition();
    },
    dataFilter (node, val) {
      if (
        !!~node.text.indexOf(val) ||
        !!~node.text.toUpperCase().indexOf(val.toUpperCase())
      ) {
        return true;
      }
    },
    changeTypeTab (typeObjList, index) {
      // 筛选类别Tab切换

      this.typeObjList = typeObjList;
      this.typeCurrentIndex = index;
    },
    typeChange (obj) {
      localStorage.setItem("emptyRes", 0);

      this.categoryId = obj.value.split("_")[1];
      this.categoryName = obj.label;
      this.pageObj.pageNum = 1;
      this.$router.push({
        path: "/search",
        query: {
          categoryId: obj.value.split("_")[1],
        },
      });
    },
    cancelClick () {
      this.isNoCart = false
    },
    // 点击立即开通
    openMemberClick () {
      this.isVisible = true
      this.isNoCart = false
    },
    memberHidden (val) {
      this.isVisible = val
    },
    isBuySuccess (val) {
      this.isvisib = val
    },
    changeMemType (val) {
      this.onceNum = val
    },
  },
  watch: {
    $route (newval, oldval) {
      const {
        query: { categoryId, name },
      } = newval;
      const {
        query: { categoryId: oldCategoryId, name: oldName },
      } = oldval;
      if (categoryId !== oldCategoryId || name !== oldName) {
        this.categoryName = name;
        this.pageObj.pageNum = 1;
        (this.checkedRender = []), (this.checkedSoftWare = []);
        this.query.copyright.id = "";
        this.query.copyright.name = "";
        this.query.surfaceNum = null;
        this.query.isAuth = null;
        this.query.sortType = 5;
        this.query.animationChecked = false;
        this.query.bindChecked = false;
        this.query.scanning = false;
        this.query.omniverse = false;
        this.query.isFree = false;
        this.query.isCharge = false;
        this.query.mxTypeFlag = false;
        this.queryAssetsByCondition();
        this.classIdApi();
      }
    },
    countNumHY: {
      handler (val) {
        this.SET_COUNT_HY(val)
      },
      immediate: true
    },
    countNumMF: {
      handler (val) {
        this.SET_COUNT_MF(val)
      },
      immediate: true
    }
  },
};

</script>

<style lang="less" scoped>
.home-box {
  min-width: 1000px;
  min-height: 100vh;
  background-color: #fff;
  margin-bottom: 30px;
}

@keyframes down {
  0% {
    height: 0;
  }

  100% {
    height: 550px;
  }
}

@keyframes up {
  0% {
    height: 550px;
  }

  100% {
    height: 0px;
  }
}

._content {
  padding: 20px;
  width: 25%;

  .el-tag {
    background-color: rgb(255, 239, 239);
    display: inline-block;
    height: 32px;
    padding: 0 10px;
    line-height: 30px;
    font-size: 12px;
    color: #000000;
    border-radius: 4px;
    box-sizing: border-box;
    white-space: nowrap;
    display: inline-block;
    background-color: #2b3335;
    border-radius: 4px;
    margin-right: 10px;
    line-height: 32px;
    border: none;
    color: #fff;
    margin-top: 10px;
    font-size: 12px;
  }
}

._assets_c {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;

  .item-detail-model {
    width: 100%;
    background: #141e22;
    transition: all 0.3s;
    overflow: hidden;
    display: flex;

    &.show {
      height: 550px;
    }

    &.down-animate {
      animation: down 0.3s linear 1 alternate forwards;
    }

    &.up-animate {
      animation: up 0.3s linear 1 alternate forwards;
    }

    .banner {
      width: 75%;
      height: 550px;
    }

    .content {
      width: 25%;
    }
  }

  ._a_i {
    width: 315px;
    height: 315px;
    line-height: 200px;
    border-top: 1px solid #fff;
    text-align: center;
    border-left: 1px solid #fff;
    border-right: 1px solid #ededed;
    border-bottom: 1px solid #ededed;
    background-color: #f7f7f7;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;

    .item-show {
      display: block !important;
      transition: all linear 0.3;
      opacity: 0.9;
    }

    &:hover {
      .none {
        display: block !important;
        transition: all linear 0.3;
        opacity: 0.9;
      }
    }

    .absolute_top {
      position: absolute;
      opacity: 0;
      width: 315px;
      height: 60px;
      background-color: rgba(126, 126, 126, 0.7);
      top: 0;
      display: none;
      line-height: 50px;
      text-align: center;
      color: #fff;
      font-size: 18px;

      .cviplogo {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 40px;
        height: 40px;
      }
    }

    .absolute_bottom {
      position: absolute;
      width: 315px;
      height: 50px;
      line-height: 50px;
      color: #fff;
      font-size: 12px;
      text-align: center;
      background-color: rgba(126, 126, 126, 0.7);
      bottom: 0;
      display: none;

      .cart {
        font-size: 24px;
        position: absolute;
        right: 10px;
        top: 13px;
      }
    }

    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      max-height: 100%;
      max-width: 100%;
      vertical-align: middle;
      border-radius: 2px;
    }
  }
}

._s_c {
  // width: 1200px;
  margin: 0 auto;
  min-height: 25vh;

  .title {
    margin: 0;
    padding-left: 20px;
    box-sizing: border-box;
    border-bottom: medium none;
    line-height: 63px;
    height: 63px;
    color: #242424;
    font-size: 24px;
  }

  .filter {
    margin-bottom: 30px;
    height: 55px;
    line-height: 55px;
    padding: 0 20px;
    border: 1px solid transparent;
    color: #333;
    border-top: 1px solid #e0dede;
    background-color: #efefef;
    border-bottom: 1px solid #ededed;
  }

  .item {
    float: left;
    padding: 0 10px;
    font-size: 14px;
    position: relative;
    cursor: pointer;

    .type-drop {
      position: absolute;
      left: 0;
      top: 100%;
      width: 800px;
      height: 450px;
      display: flex;
      align-items: flex-start;
      z-index: 1000;
      background: #fff;
      border-radius: 4px;
      overflow: hidden;
      box-shadow: 0 6px 12px rgb(0 0 0 / 18%);

      .tab-list {
        width: 200px;
        height: 100%;
        padding: 0 30px;
        overflow-y: auto;
        background: #1c6f6e;

        &::-webkit-scrollbar {
          display: none;
        }

        .tab {
          padding-bottom: 14px;
          border-bottom: 1px solid #fff;
          margin-bottom: 13px;

          &.active {
            .title {
              color: #ff8135;
            }

            .txt {
              span {
                color: #ff8135;
              }
            }
          }

          &:first-child {
            padding-top: 20px;
          }

          &:last-child {
            margin-bottom: 0;
            border-bottom: none;
          }

          .title {
            position: relative;
            height: auto;
            font-size: 16px;
            line-height: 1.5;
            color: #fff;
            padding: 0;

            &::before {
              position: absolute;
              content: "";
              top: 50%;
              transform: translateY(-50%);
              right: 0;
              width: 8px;
              height: 14px;
              background: url(../assets/tools/arr-right.png) no-repeat;
              background-size: 100% 100%;
            }
          }

          .txt {
            height: auto;
            line-height: 1.5;
            margin-top: 10px;

            span {
              display: inline-block;
              height: auto;
              font-size: 14px;
              line-height: 1.5;
              color: #fff;
              margin-right: 5px;
            }
          }
        }
      }

      .right-content {
        width: calc(800px - 200px);
        height: 100%;
        overflow-y: auto;

        &::-webkit-scrollbar {
          display: none;
        }

        .content-list {
          display: flex;
          align-items: baseline;
          justify-content: flex-start;
          padding-bottom: 30px;

          &:first-child {
            padding-top: 30px;
          }

          &:last-child {
            margin-bottom: 0;
          }

          .title {
            min-width: 90px;
            height: auto;
            font-size: 16px;
            line-height: 1.5;
            color: #606266;
            padding-left: 30px;
            margin-right: 50px;

            &:hover {
              color: #1c6f6e;
            }
          }

          .txt {
            height: auto;
            font-size: 14px;
            line-height: 24px;
            color: #969696;
            flex: 1;

            span {
              position: relative;
              display: inline-block;

              &:hover {
                color: #1c6f6e;
              }

              &::after {
                display: inline-block;
                content: "|";
                vertical-align: baseline;
                font-size: 14px;
                line-height: 24px;
                color: #969696;
                margin: 0 10px;
              }

              &:last-child {
                &::after {
                  display: none;
                }
              }
            }
          }
        }
      }
    }

    .drop {
      min-width: 160px;
      position: absolute;
      line-height: 35px;
      background-color: #fff;
      top: 100%;
      left: 0;
      z-index: 1000;
      padding: 5px 0;
      box-shadow: 0 6px 12px rgb(0 0 0 / 18%);
      border-radius: 4px;

      .button {
        height: 26px;
        display: inline-block;
        width: 120px;
        background-color: #4d75a0;
        color: #ffffff;
        text-align: center;
        line-height: 26px;
        font-size: 12px;
      }

      .option {
        padding: 0 20px;
        cursor: pointer;
        height: 26px;
        line-height: 26px;

        &:hover {
          color: #4d75a0;
          background-color: #f1f1f1;
        }
      }

      .text {
        height: 26px;
        line-height: 26px;
        font-size: 12px;
        text-align: center;
        color: #888888;
      }
    }
  }
}

.__a_noresult {
  color: #d3d3d3;
  font-size: 36px;
  text-align: center;
  text-shadow: 1px 1px 0 #fff;
  width: 100%;
  font-style: italic;
  margin-top: 10%;
}
</style>
<style lang="less" scoped>
.__s {
  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #242424;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #242424 !important;
    border-color: #242424 !important;
  }

  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #242424 !important;
  }

  .el-checkbox__inner:hover {
    border-color: #242424;
  }

  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #242424 !important;
    color: #fff;
  }

  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #242424;
    color: #fff;
  }
}
</style>
<style lang="less" scoped>
.commercial_use_mark {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 40px;
  height: 40px;
  border-radius: 20px;

  img {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: contain;
    border: none;
    width: 100%;
    height: 100%;
  }
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  user-select: none;
  background-color: darkcyan;
}

.memberitem {
  /deep/.el-checkbox__label {
    margin-left: 24px;
    font-weight: bold;
    font-size: 16px;
    color: #E0B58C;

  }

}

.viplogo {
  width: 20%;
  position: absolute;
  top: 14px;
  left: 33px;
}

.dialogFox {
  user-select: none;
  width: 400px;
  height: 60px;
  border-radius: 10px;
  background-color: #FEF0F0;
  color: #f14853;
  position: fixed;
  top: 50%;
  left: 40%;
  z-index: 1000;
  text-align: center;
  line-height: 60px;
  font-size: 16px;
  border: 1px solid #fff;

  .cancelX {
    width: 30px;
    height: 30px;
    text-align: center;
    font-size: 18px;
    position: absolute;
    top: -10px;
    right: 0;
    cursor: pointer;
  }
}
</style>
